import React from 'react';
import styled from '@emotion/styled';

// helpers
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../helpers';

// styles
import {
  ActionColumnHeaderItem,
  DeferButton,
  ActionButtonWrapper,
  TableRow,
  TableHeaderItem,
  TableWrapper,
} from './Table-styles';
import {TextDefault, TextSmall} from '../../styles';

// types
import {SubscriptionPayment} from '../../services/ApiService/types';

type Props = {
  payments: SubscriptionPayment[];
  onDeferPaymentClick: (
    e: React.MouseEvent,
    payment: SubscriptionPayment,
  ) => void;
};

const PaymentsTableWrapper = styled(TableWrapper)`
  thead p {
    white-space: normal;
  }
`;

const TablePaymentsSubscription = ({payments, onDeferPaymentClick}: Props) => {
  const {t} = useTranslation();

  return (
    <PaymentsTableWrapper borderAxis="none">
      <thead>
        <tr>
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('subscription_payment_paymentNumber')}
            </TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_date')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_status')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('subscription_amount_short')}
            </TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('subscription_tax')}
            </TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('subscription_payment_paymentAmount')}
            </TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('subscription_payment_balanceWithTax')}
            </TextDefault>
          </TableHeaderItem>
          <ActionColumnHeaderItem />
        </tr>
      </thead>
      <tbody>
        {payments.map((payment) => (
          <TableRow key={payment.id}>
            <td>
              <TextSmall>#{payment.paymentNumber}</TextSmall>
            </td>
            <td>
              <TextSmall>{payment.paymentDate}</TextSmall>
            </td>
            <td>
              <TextSmall>{payment.status}</TextSmall>
            </td>
            <td>
              <TextSmall>{formatCurrency(payment.paymentAmount)}</TextSmall>
            </td>
            <td>
              <TextSmall>{formatCurrency(payment.tax)}</TextSmall>
            </td>
            <td>
              <TextSmall>{formatCurrency(payment.paymentTotal)}</TextSmall>
            </td>
            <td>
              <TextSmall>{formatCurrency(payment.balanceWithTax)}</TextSmall>
            </td>
            <ActionButtonWrapper>
              {payment.canBeDeferred && (
                <DeferButton
                  variant="outlined"
                  onClick={(e) => onDeferPaymentClick(e, payment)}>
                  {t('subscription_payment_defer')}
                </DeferButton>
              )}
            </ActionButtonWrapper>
          </TableRow>
        ))}
      </tbody>
    </PaymentsTableWrapper>
  );
};

export default TablePaymentsSubscription;
